import styled from '@emotion/styled'
import { PharmacH4, PharmacIcon, PharmacIconProps, PharmacText } from '@pharmac/ui'
import { useTranslation } from 'react-i18next'

type NoResultsResponseProps = {
  title?: string
  icon?: PharmacIconProps['icon']
  description?: string
}

const NoResultsResponseRoot = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 324px;
  width: 100%;

  padding: 0 var(--spacing-small);

  background-color: var(--extranet-light-purple);

  border-radius: var(--border-radius-small);
`

const NoResultsResponseIcon = styled.div`
  width: 200px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  svg {
    width: 150px;
    height: 150px;

    color: var(--color-primary);
  }
`

const NoResultsResponseTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 var(--spacing-small);
  color: var(--color-purple);
  text-align: center;
`

const NoResultsResponseText = styled(PharmacText)`
  font-size: 17px;
  color: var(--color-accent-8);
  font-family: var(--font-family-primary);
`

export const NoResultsResponse = ({ title, icon, description }: NoResultsResponseProps) => {
  const { t } = useTranslation('common')

  return (
    <NoResultsResponseRoot>
      <NoResultsResponseIcon>
        <PharmacIcon icon={icon || 'search'} />
      </NoResultsResponseIcon>
      <NoResultsResponseTextContainer>
        <PharmacH4 marginMediumTop>
          {!!title ? title : t('noSearchResultsTitle', { ns: 'common' })}
        </PharmacH4>
        <NoResultsResponseText marginMediumTop>
          {!!description ? description : t('noSearchResultsDescription', { ns: 'common' })}
        </NoResultsResponseText>
      </NoResultsResponseTextContainer>
    </NoResultsResponseRoot>
  )
}
